import axios, { AxiosResponse, CancelToken } from 'axios'
import { apiPath, getAPIURL } from 'constants/environment'
import {
  DocumentNode,
  OperationVariables,
  QueryHookOptions,
  QueryResult,
  TypedDocumentNode,
  useQuery,
} from '@apollo/client'
import useJamesApolloError from './useJamesApolloError'

export const fetchInfo =
  <T>(query: string, token?: CancelToken) =>
  async () => {
    return (
      axios
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .post<any, AxiosResponse<{ data: T }>>(
          `${getAPIURL()}${apiPath}`,
          { query },
          { withCredentials: true, cancelToken: token },
        )
        .catch((thrown) => {
          return thrown
        })
    )
  }

export const useJamesApolloQuery = <TData = unknown, TVariables extends OperationVariables = OperationVariables>(
  query: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options?: QueryHookOptions<TData, TVariables>,
): QueryResult<TData, TVariables> => {
  const onError = useJamesApolloError(options)
  return useQuery(query, {
    ...options,
    onError,
  })
}
